export default "/images/vendor/flag-icon-css/flags/1x1/np.svg?e700d833be637cc3507b809c92ddbe31";